import axios from "axios";
import { API_BASE_URL } from "./config";

const BLOG_BASE_URL = `${API_BASE_URL}/blog`;

export const fetchBlogList = async (category = "all", page = 1, perPage = null) => {
    try {
        const params = {
            category: category === "all" ? "all" : category,
            page: page,
            _ts: Date.now(),
        };

        // Add per_page parameter if provided
        if (perPage !== null) {
            params.per_page = perPage;
        }

        const response = await axios.get(BLOG_BASE_URL, {
            params: params,
        });

        return response?.data || null;
    } catch (error) {
        throw error;
    }
};

export const fetchBlogBySlug = async (slug) => {
    if (!slug || typeof slug !== "string") {
        throw new Error("fetchBlogBySlug requires a valid slug");
    }

    try {
        const response = await axios.get(`${BLOG_BASE_URL}/${slug}`, {
            params: {
                _ts: Date.now(),
            },
        });

        return response?.data || null;
    } catch (error) {
        throw error;
    }
};

